var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isOpen)?_c('div',{staticClass:"popup-container"},[_c('div',{staticClass:"popup-wrap"},[(_vm.name === 'success')?_c('SuccessPopup'):_vm._e(),(_vm.name === 'coupon')?_c('CouponPopup',{attrs:{"coupon":_vm.data}}):_vm._e()],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }